export default "__VITE_ASSET__C5kDZcY5__"